exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".a-wishlist-icon[data-v-bab91ffe]{position:relative}.badge[data-v-bab91ffe]{position:absolute;bottom:2.2em;left:4.2em;font-size:0.6em;padding:0.3em 0;border-radius:100%;width:2.2em;min-height:2.2em}\n", ""]);

// exports
